import { $http } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    list: [],
    links: {},
    meta: {},
    form: {
      id: null,
      image: null,
      name: null,
      phone: null,
      address: null,
      password: null,
    },
  },
  mutations: {
    SET_GUEST: (state, data) => Object.assign(state.form, data),
    STORE_GUEST: (state, data) => state.list.unshift(data),
    SET_GUESTS: (state, data) => {
      state.list = data.data;
      state.links = data.links;
      state.meta = data.meta;
    },
    UPDATE_GUEST: (state, data) => {
      state.list = state.list.filter((item) => item.id !== data.id);
      state.list.unshift(data);
    },
    DELETE_GUEST: (state, data) => {
      const item = state.list.find((item) => item.id === data);
      state.list.splice(state.list.indexOf(item), 1);
    },
  },
  getters: {
    user: (state) => {
      let user = new FormData();
      user.append("name", state.form.name);
      user.append("phone", state.form.phone);
      if (state.form.password) user.append("password", state.form.password);
      user.append("image", state.form.image);
      user.append("address", state.form.address);
      return user;
    },
  },
  actions: {
    async get({ commit }, { page, phone, name }) {
      // Remove leading zeros from the phone number
      const sanitizedPhone = phone.replace(/^0+/, "");
      const { payload } = await $http.get(
        `admin/visitors?page=${page}&phone=${sanitizedPhone}&name=${name}`
      );
      commit("SET_GUESTS", payload);
    },
    async show({ commit }, id) {
      const { payload } = await $http.get(`admin/visitors/${id}`);
      commit("SET_GUEST", payload);
    },
    async store({ getters }) {
      return await $http.post("admin/visitors", getters.user);
    },
    async update({ state, getters }) {
      return await $http.post(`admin/visitors/${state.form.id}`, getters.user);
    },
    async delete(_, id) {
      return await $http.delete(`admin/visitors/${id}`);
    },
  },
};
